const defaultRegion = 'ru-RU';

const yearFormatter = new Intl.DateTimeFormat(defaultRegion, {year: 'numeric'});
const monthFormatter = new Intl.DateTimeFormat(defaultRegion, {month: 'numeric'});

const getYear = (date) => yearFormatter.format(new Date(date));
const getMonth = (date) => monthFormatter.format(new Date(date));

module.exports = {
    defaultRegion,
    getYear,
    getMonth,
};
